import Index from '@tunnel-components/layouts/layout/container'

/**
 * @export Container
 */

export default Index



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/layouts/layout/index.ts